export interface SupabaseConfig {
  url: string
  anonKey: string
}

const DEVELOPMENT: SupabaseConfig = {
  url: 'https://qgmsycavewajuhslwxzi.supabase.co',
  anonKey:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFnbXN5Y2F2ZXdhanVoc2x3eHppIiwicm9sZSI6ImFub24iLCJpYXQiOjE3OTA5MzMwMTEsImV4cCI6MjEwNjUwOTAxMX0.DF-tKFR-BzujBRKgLKjVqAeyFAZjPVvYij1XDc3qlyU',
}

const PRODUCTION: SupabaseConfig = {
  url: 'https://odkgdixlgvjftimvdezw.supabase.co',
  anonKey:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9ka2dkaXhsZ3ZqZnRpbXZkZXp3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3OTA5MzE3OTMsImV4cCI6MjEwNjUwNzc5M30.4a2c2afdpDVfSGUJ0mC-vbhvomjtuPxZ79Du0BkwKyk',
}

export const supabaseConfigFor = (mode: string): SupabaseConfig => (mode === 'production' ? PRODUCTION : DEVELOPMENT)
